<template>
  <AisCurrentRefinements class="current-product-refinements">
    <template #default="{ items }">
      <ul class="px-container lg:px-0 pb-4 flex lg:flex-wrap gap-x-6 gap-y-4 list-reset overflow-x-auto">
        <FilterSelectionListAttribute v-for="item in items" :key="item.attribute" :item="item" />
      </ul>
    </template>
  </AisCurrentRefinements>
</template>

<script setup lang="ts">
import FilterSelectionListAttribute from './FilterSelectionListAttribute.vue'
</script>

<style>
.current-product-refinements.ais-CurrentRefinements--noRefinement { display: none; }
</style>
